import React, { FC, useState } from "react";

import { useTranslation } from "react-i18next";

import { AttachmentIcon } from "@/assets/icons";
import { Card } from "@/components/molecules";
import { Request } from "@/shared/domain";

import RequestModal from "../RequestModal/RequestModal";
import { StatusColorMap } from "../utils";
import { StyledDocumentsCounter } from "./styled";

type RequestCardProps = {
    request: Request;
    hidePolicyholder?: boolean;
};

const RequestCard: FC<RequestCardProps> = ({ request }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <Card
            clickable={!!request.userRequestDocument?.length}
            statusText={request.status.name}
            statusColor={StatusColorMap[request.status.id]}
            dataTestId={`request_cards-card-${request.id}`}
            title={request.requestActionName}
            text={request.remark}
            onClickCard={() => setOpen(true)}
            date={request.updateDatetime}
            infos={[{ title: t("Requests.Label.AskBy"), content: request.userName }]}
        >
            {!!request.userRequestDocument?.length && (
                <StyledDocumentsCounter>
                    <AttachmentIcon />
                    <RequestModal request={request} open={open} setOpen={setOpen} />
                    <span>{`${request.userRequestDocument.length} ${t("Requests.Label.Documents")}`}</span>
                </StyledDocumentsCounter>
            )}
        </Card>
    );
};

export default RequestCard;
